
import React from 'react';
import './WeatherCard.css';


const WeatherCard = ({maxTemp, minTemp, icon, day}) => {
	

	return(
		<div className='weather-card'>
			<h4>{day}</h4>
			<img src={`https://openweathermap.org/img/wn/${icon}.png`} alt='rain' />
			<p>{maxTemp}°</p>
			<p>{minTemp}°</p>
			
		</div>
		)
}

export default WeatherCard

				